import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-xxxl-3" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing chat-sidebar" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "chat-tabs" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"chat-users-list\"><div class=\"single-user-item position-relative\"><div class=\"d-flex align-items-center\"><div class=\"ms-12\"><span class=\"title d-block text-black fs-md-15 fs-lg-16 fw-medium\"> Jacob Linowiski <span class=\"ms-5 text-muted fw-normal fs-12\"> 10:30 am </span></span><span class=\"d-block text-black text-truncate\" style=\"max-width:200px;\"> Hey Victor! Could you please... </span></div></div></div><div class=\"single-user-item position-relative\"><div class=\"d-flex align-items-center\"><div class=\"ms-12\"><span class=\"title d-block text-black fs-md-15 fs-lg-16 fw-medium\"> Jacob Linowiski <span class=\"ms-5 text-muted fw-normal fs-12\"> 10:30 am </span></span><span class=\"d-block text-black text-truncate\" style=\"max-width:200px;\"> Hey Victor! Could you please... </span></div></div></div><div class=\"single-user-item position-relative\"><div class=\"d-flex align-items-center\"><div class=\"ms-12\"><span class=\"title d-block text-black fs-md-15 fs-lg-16 fw-medium\"> Jacob Linowiski <span class=\"ms-5 text-muted fw-normal fs-12\"> 10:30 am </span></span><span class=\"d-block text-black text-truncate\" style=\"max-width:200px;\"> Hey Victor! Could you please... </span></div></div></div><div class=\"single-user-item position-relative\"><div class=\"d-flex align-items-center\"><div class=\"ms-12\"><span class=\"title d-block text-black fs-md-15 fs-lg-16 fw-medium\"> Jacob Linowiski <span class=\"ms-5 text-muted fw-normal fs-12\"> 10:30 am </span></span><span class=\"d-block text-black text-truncate\" style=\"max-width:200px;\"> Hey Victor! Could you please... </span></div></div></div><div class=\"single-user-item position-relative\"><div class=\"d-flex align-items-center\"><div class=\"ms-12\"><span class=\"title d-block text-black fs-md-15 fs-lg-16 fw-medium\"> Jacob Linowiski <span class=\"ms-5 text-muted fw-normal fs-12\"> 10:30 am </span></span><span class=\"d-block text-black text-truncate\" style=\"max-width:200px;\"> Hey Victor! Could you please... </span></div></div></div></div>", 1)
const _hoisted_7 = { class: "col-lg-8 col-xxxl-9" }
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing chat-card" }
const _hoisted_9 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ms-15" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" }, "Brad Traversy"),
    /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "EMOCIÓN - CATEGORIA")
  ])
], -1)
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold flaticon-form me-8" }, null, -1)
const _hoisted_15 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_16 = {
  class: "chat-list",
  ref: "chatBox"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"chat-item position-relative\"><span class=\"d-block text-black fs-md-15 fs-lg-16 fw-medium mb-10\"> Brad Traversy <span class=\"fs-12 text-muted fw-noarmal ms-5\">10:29</span></span><div class=\"message position-relative\"><div class=\"inner\"><p class=\"fs-md-15 fs-lg-16 lh-base\"> Hey Victor! Could you please give me the transaction number that we provide yesterday? We need this for the invoice. After that I will give you the full invoice with payment. </p></div></div></div><div class=\"chat-item position-relative right\"><span class=\"d-block text-black fs-md-15 fs-lg-16 fw-medium mb-10\"> Virtualia <span class=\"fs-12 text-muted fw-noarmal ms-5\">10:29</span></span><div class=\"message position-relative\"><div class=\"inner\"><p class=\"fs-md-15 fs-lg-16 lh-base\"> Hola, ¿En qué te puedo ayudar el día de hoy? </p></div></div></div>", 2)
const _hoisted_19 = [
  _hoisted_17
]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<form><div class=\"write-your-message position-relative\"><div class=\"write-message position-relative\"><input disabled type=\"text\" class=\"input-message d-block w-100 text-black fs-14\" placeholder=\"Conversación finalizada, no puede responder.\"></div><div class=\"buttons-list items-center\"><button type=\"button\" class=\"border-0 d-inline-block position-relative text-center btn btn-outline-secondary\" disabled><i class=\"flaticon-airplane\"></i></button></div></div></form>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: {name:'chats-ia'},
              class: "text-decoration-none fw-medium transition text-center d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" IA ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name:'chats-manual'},
              class: "text-decoration-none fw-medium transition text-center d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Manuales ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name:'chats-finalizados'},
              class: "active text-decoration-none fw-medium transition text-center d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Finalizados ")
              ]),
              _: 1
            })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item d-flex align-items-center",
                  to: {name:'conversaciones-detalles'}
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createTextVNode(" Ver detalles conversacion ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _hoisted_19, 512),
          _hoisted_20
        ])
      ])
    ])
  ]))
}